// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import ReactPaginate from "react-paginate";

// const MembersTable = () => {
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [filter, setFilter] = useState(""); 
//     const [currentPage, setCurrentPage] = useState(0);
//     const itemsPerPage = 10;

//     const userId = sessionStorage.getItem("userId"); 

//     useEffect(() => {
//         axios.get(`http://localhost:8003/member/api/clubs/members/${userId}`)
//             .then(response => {
//                 setData(response.data);
//                 setFilteredData(response.data);
//             })
//             .catch(error => console.error("Error fetching data:", error));
//     }, [userId]);

//     // Designation filter logic
//     // const handleFilterChange = (event) => {
//     //     const value = event.target.value;
//     //     setFilter(value);
//     //     if (value === "") {
//     //         setFilteredData(data);
//     //     } else if (value === "Cabinet Members") {
//     //         const excluded = ["Region Chairperson", "Zone Chairperson", "GAT Coordinators", "President", "Secretary", "Treasurer"];
//     //         setFilteredData(data.filter(member => !excluded.includes(member.designation)));
//     //     } else if (value === "GAT Coordinators") {
//     //         const gatRoles = ["GLT", "GMT", "GST", "GET", "LCIF", "Leo", "Quest"];
//     //         setFilteredData(data.filter(member => gatRoles.includes(member.designation)));
//     //     } else {
//     //         setFilteredData(data.filter(member => member.designation === value));
//     //     }
//     // };

//     const handleFilterChange = (event) => {
//         const value = event.target.value;
//         setFilter(value);
    
//         if (value === "") {
//             setFilteredData(data);
//         } else if (value === "Cabinet Members") {
//             const excluded = ["Region Chairperson", "Zone Chairperson", "GAT Coordinators", "President", "Secretary", "Treasurer"];
//             setFilteredData(data.filter(member => 
//                 !excluded.includes(member.designation) && !excluded.includes(member.cabinetDesignation)
//             ));
//         } else if (value === "GAT Coordinators") {
//             const gatRoles = ["GLT", "GMT", "GST", "GET", "LCIF", "Leo", "Quest"];
//             setFilteredData(data.filter(member => 
//                 gatRoles.some(role => 
//                     member.designation?.includes(role) || member.cabinetDesignation?.includes(role)
//                 )
//             ));
    
//         } else {
//             setFilteredData(data.filter(member => 
//                 member.designation === value || member.cabinetDesignation === value
//             ));
//         }
//     };
    

//     // Pagination logic
//     const pageCount = Math.ceil(filteredData.length / itemsPerPage);
//     const handlePageClick = ({ selected }) => setCurrentPage(selected);
//     const displayedItems = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//     return (
//         <div className="container mx-auto p-4">
//             <h2 className="text-2xl font-bold mb-4">Member Groups</h2>

//             {/* Filter Dropdown */}
//             <select className="border p-2 mb-4" onChange={handleFilterChange} value={filter}>
//                 <option value="">All</option>
//                 <option value="Region Chairperson">Region Chairperson</option>
//                 <option value="Zone Chairperson">Zone Chairperson</option>
//                 <option value="GAT Coordinators">GAT Coordinators (GLT, GMT, GST, GET, LCIF, Leo, Quest)</option>
//                 <option value="President">President</option>
//                 <option value="Secretary">Secretary</option>
//                 <option value="Treasurer">Treasurer</option>
//                 <option value="Cabinet Members">Cabinet Members</option>
//             </select>

//             {/* Table */}
//             <table className="min-w-full bg-white border">
//                 <thead>
//                     <tr className="bg-gray-200">
//                         <th className="border px-4 py-2">Club Name</th>
//                         <th className="border px-4 py-2">Member Name</th>
//                         <th className="border px-4 py-2">Designation</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {displayedItems.length > 0 ? (
//                         displayedItems.map((member, index) => (
//                             <tr key={index} className="text-center">
//                                 <td className="border px-4 py-2">{member.clubName}</td>
//                                 <td className="border px-4 py-2">{member.memberName || member.cabinetMember}</td>
//                                 <td className="border px-4 py-2">{member.designation || member.cabinetDesignation}</td>
//                             </tr>
//                         ))
//                     ) : (
//                         <tr>
//                             <td colSpan="3" className="border px-4 py-2 text-center">No data available</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>

//             {/* Pagination */}
//             {pageCount > 1 && (
//                 <ReactPaginate
//                     previousLabel={"Previous"}
//                     nextLabel={"Next"}
//                     breakLabel={"..."}
//                     pageCount={pageCount}
//                     marginPagesDisplayed={2}
//                     pageRangeDisplayed={3}
//                     onPageChange={handlePageClick}
//                     containerClassName={"pagination flex justify-center mt-4"}
//                     activeClassName={"font-bold"}
//                     pageClassName={"mx-2"}
//                 />
//             )}
//         </div>
//     );
// };

// export default MembersTable;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Form, Container, Pagination, Row, Col } from "react-bootstrap";

const MembersTable = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState(""); 
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const userId = sessionStorage.getItem("userId");

    useEffect(() => {
        axios.get(`https://lionsdirectoryapi.emedha.in/member/api/clubs/members/${userId}`)
            .then(response => {
                setData(response.data);
                setFilteredData(response.data);
            })
            .catch(error => console.error("Error fetching data:", error));
    }, [userId]);

    // const handleFilterChange = (event) => {
    //     const value = event.target.value;
    //     setFilter(value);

    //     if (value === "") {
    //         setFilteredData(data);
    //     } else if (value === "Cabinet Members") {
    //         const excluded = ["Region Chairperson", "Zone Chairperson", "GAT Coordinators", "President", "Secretary", "Treasurer"];
    //         setFilteredData(data.filter(member => 
    //             !excluded.includes(member.designation) && !excluded.includes(member.cabinetDesignation)
    //         ));
    //     } else if (value === "GAT Coordinators") {
    //         const gatRoles = ["GLT", "GMT", "GST", "GET", "LCIF", "Leo", "Quest"];
    //         setFilteredData(data.filter(member => 
    //             gatRoles.some(role => 
    //                 member.designation?.includes(role) || member.cabinetDesignation?.includes(role)
    //             )
    //         ));
    //     } else {
    //         setFilteredData(data.filter(member => 
    //             member.designation === value || member.cabinetDesignation === value
    //         ));
    //     }
    // };

    // Pagination Logic
    
    
    const handleFilterChange = (event) => {
        const value = event.target.value;
        setFilter(value);
    
        if (!data.length) {
            console.warn("Data is not yet loaded, skipping filtering.");
            return;
        }
    
        if (value === "") {
            setFilteredData(data); // Reset to all members when no filter is applied
            return;
        }
    
        let filtered = [];
    
        if (value === "Cabinet Members") {
            const excludedRoles = ["Region Chairperson", "Zone Chairperson", "GAT Coordinators", "President", "Secretary", "Treasurer"];
            filtered = data.filter(member =>
                !excludedRoles.includes(member.designation?.trim()) &&
                !excludedRoles.includes(member.cabinetDesignation?.trim())
            );
        } else if (value === "GAT Coordinators") {
            const gatRoles = ["GLT", "GMT", "GST", "GET", "LCIF", "Leo", "Quest"];
            filtered = data.filter(member =>
                gatRoles.some(role =>
                    (member.designation && member.designation.toLowerCase().includes(role.toLowerCase())) ||
                    (member.cabinetDesignation && member.cabinetDesignation.toLowerCase().includes(role.toLowerCase()))
                )
            );
        } else {
            filtered = data.filter(member =>
                (member.designation && member.designation.trim() === value) ||
                (member.cabinetDesignation && member.cabinetDesignation.trim() === value)
            );
        }
    
        if (filtered.length === 0) {
            console.warn(`No matching data found for: ${value}`);
        }
    
        setFilteredData(filtered);
    };
    
    
    
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const displayedItems = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const handlePageClick = (selectedPage) => {
        setCurrentPage(selectedPage);
    };

    return (
        <Container className="mt-4">
            <h2 className="text-center mb-4" style={{ color: "navy", fontWeight: "bold" }}>Member Groups</h2>

            {/* Filter Dropdown */}
            <Form.Select className="mb-4" value={filter} onChange={handleFilterChange} style={{ maxWidth: "300px", border: "2px solid gold" }}>
                <option value="">All Members</option>
                <option value="Region Chairperson">Region Chairperson</option>
                <option value="Zone Chairperson">Zone Chairperson</option>
                <option value="GAT Coordinators">GAT Coordinators (GLT, GMT, GST, GET, LCIF, Leo, Quest)</option>
                <option value="President">President</option>
                <option value="Secretary">Secretary</option>
                <option value="Treasurer">Treasurer</option>
                <option value="Cabinet Members">Cabinet Members</option>
            </Form.Select>

            {/* Member Table */}
            <Table striped bordered hover responsive className="text-center">
                <thead style={{ backgroundColor: "navy", color: "white" }}>
                    <tr>
                        <th>Club Name</th>
                        <th>Member Name</th>
                        <th>Designation</th>
                    </tr>
                </thead>
                <tbody>
                    {displayedItems.length > 0 ? (
                        displayedItems.map((member, index) => (
                            <tr key={index}>
                                <td>{member.clubName}</td>
                                <td>{member.memberName || member.cabinetMember}</td>
                                <td>{member.designation || member.cabinetDesignation}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center">No data available</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {/* Pagination Outside Table */}
            {pageCount > 1 && (
                <Row className="mt-3">
                    <Col className="d-flex justify-content-end">
                        <Pagination>
                            <Pagination.Prev 
                                disabled={currentPage === 0} 
                                onClick={() => handlePageClick(currentPage - 1)} 
                            />

                            {currentPage > 2 && <Pagination.Ellipsis disabled />}
                            
                            {[...Array(pageCount)].slice(
                                Math.max(0, currentPage - 2), 
                                Math.min(pageCount, currentPage + 3)
                            ).map((_, index) => (
                                <Pagination.Item 
                                    key={index + Math.max(0, currentPage - 2)}
                                    active={index + Math.max(0, currentPage - 2) === currentPage} 
                                    onClick={() => handlePageClick(index + Math.max(0, currentPage - 2))}
                                >
                                    {index + Math.max(0, currentPage - 2) + 1}
                                </Pagination.Item>
                            ))}

                            {currentPage < pageCount - 3 && <Pagination.Ellipsis disabled />}
                            
                            <Pagination.Next 
                                disabled={currentPage === pageCount - 1} 
                                onClick={() => handlePageClick(currentPage + 1)} 
                            />
                        </Pagination>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default MembersTable;
